export default __webpack_public_path__ + "968ca3aad96ac8fd027b736dc2b887e0.svg";